import { useQuery } from '@tanstack/react-query';
import { Package } from 'src/models/package/_types';
import { fetchPackages } from 'src/models/package/package';
import { PackageAutocomplete } from 'src/shared/PackageAutocomplete';

interface PackageFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const PackageFilter: React.FC<PackageFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple,
}) => {
  const packageIds = value ? String(value).split(',') : [];

  const { data: packages = [] } = useQuery<Package[]>({
    queryKey: ['packages', packageIds],
    queryFn: () => fetchPackages({ ids: packageIds }),
    enabled: !!value && valueOnly,
  });

  if (valueOnly) {
    if (multiple) {
      return <>{packages?.map((p) => p.name)?.join(', ')}</>;
    }
    return <>{packages[0]?.name || ''}</>;
  }

  return (
    <PackageAutocomplete
      label={label}
      value={multiple ? packages : packages[0] || null}
      onChange={(newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((p) => p.id).join(',')
          );
        } else {
          setValue(String((newValue as Package)?.id || ''));
        }
      }}
      multiple={multiple}
    />
  );
};
